import React from 'react';
import './ImageSkeleton.css';

const ImageSkeleton = ({ width = '100%', height = '100%', borderRadius = '0.5rem' }) => {
    return (
        <div
            className="image-skeleton"
            style={{
                width,
                height,
                borderRadius
            }}
            aria-label="Loading image"
            role="status"
        >
            <div className="skeleton-shimmer"></div>
        </div>
    );
};

export default ImageSkeleton;
